const organizationEmailTranslations = {
  label: "E-Mail-Adresse",
  email: {
    label: "E-Mail-Adresse",
  },
};

export default organizationEmailTranslations;
